import * as React from 'react';
export const IcRecentHistory = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M14 14a1 1 0 000-2h-2V9a1 1 0 00-2 0v4a1 1 0 001 1h3zm3.86-7.43a1.829 1.829 0 00-.15-.23A8 8 0 0012.05 4H12a8 8 0 00-8 7.61l-.31-.32a1.004 1.004 0 10-1.42 1.42l2 2a1 1 0 00.22.14c.033.03.07.053.11.07A1 1 0 005 15a.938.938 0 00.37-.07l.11-.07a.86.86 0 00.2-.13l2-1.88a1 1 0 00.05-1.41 1 1 0 00-1.41 0l-.25.23A6 6 0 0112 6a6 6 0 110 12 1 1 0 000 2 7.999 7.999 0 005.86-13.43z'
      fill='currentColor'
    />
  </svg>
);
